
export default {
  // Profile
  "profile_reviews": "レビュー",
  "profile_no_reviews": "まだレビューがありません",
  "profile_share_experience": "フィルムコミュニティとあなたの経験をシェアしましょう！",
  "verified_traveler": "認証済み旅行者",
  "verified_creative": "認証済みクリエイティブ",
  "verified_traveler_tooltip": "このユーザーは認証済み旅行者です",
  "verified_creative_tooltip": "認証済み写真家またはクリエイティブプロフェッショナル",
  "favorite_airports": "お気に入りの空港",
  "no_favorite_airports": "まだお気に入りの空港がありません",
  "user_favorites": "ユーザーのお気に入り",
  "manage_favorites": "お気に入りを管理"
};
